export default __webpack_public_path__ + "static/media/car15.bdf5b93a.jpg";